import { render, staticRenderFns } from "./MajoritySubfilter.vue?vue&type=template&id=a74e5242&"
import script from "./MajoritySubfilter.vue?vue&type=script&lang=js&"
export * from "./MajoritySubfilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports